"use client";
import { Box } from "@mui/material";
import React, { ReactNode } from "react";

interface ContentActionProps {
  children: ReactNode;
}
const WrapperAction = React.forwardRef(function WrapperAction(
  {
    children,
  }: ContentActionProps,
  ref
) {
  return (
    <Box className="lg:max-w-full flex justify-center xl:max-w-[400px] xl:w-full">
      <Box className="gap-[36px] grid w-full max-w-auto sm:flex sm:justify-center sm:max-w-full xl:grid">
        <Box
          className={`gap-[36px] sm:gap-[36px] grid lg:flex-1 w-auto sm:w-[600px] lg:w-[400px] xl:w-[400px]`}
        >
          <Box className={"sticky flex flex-col gap-4 self-auto h-fit !top-2"} ref={ref}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

export default WrapperAction;
